import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DemurrageDetentionStatusEnum } from '../../store/state/monitoring/models/shipment-common-models/demurrage-detention-status.model';

@Component({
    selector: 'ui-demurrage-detention-days',
    imports: [CommonModule, IntrackFeatureModule, TranslateModule],
    templateUrl: './demurrage-detention-days.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemurrageDetentionDaysComponent {
  @Input() days: number | null = null;
  @Input() remainingDays: number | null = null;
  @Input() status: DemurrageDetentionStatusEnum | null = null;
  readonly demurrageDetentionStatus = DemurrageDetentionStatusEnum;
}